import { render, staticRenderFns } from "./MyColumnsDropdown.vue?vue&type=template&id=79411450&scoped=true&"
import script from "./MyColumnsDropdown.vue?vue&type=script&lang=js&"
export * from "./MyColumnsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MyColumnsDropdown.vue?vue&type=style&index=0&id=79411450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79411450",
  null
  
)

export default component.exports